import React, { useState, useEffect } from 'react';
import moment from 'moment';
import * as Yup from 'yup';
import {
  Card,
  CardContent,
  Grid,
  Stack,
  Paper,
  Divider,
  Backdrop,
  CircularProgress,
  Button
} from '@material-ui/core';

import { useFormik, Form, FormikProvider } from 'formik';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import { baseUrl, users, claimStatuses } from '../../utils/constants';
import { useClaimsContext } from '../../context/claims_context';
import Controls from '../controls/Controls';
import RejectClaimReason from './RejectClaimReason';

export default function ClaimsApproval() {
  const { getClaimById, currentClaim, claimNo } = useClaimsContext();
  const [loading, setLoading] = useState(false);
  const [rejectionLevel, setRejectionLevel] = useState(1);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [openPopup, setOpenPopup] = useState(false);
  const userRefId = sessionStorage.getItem('userRefId');

  useEffect(() => {
    // getClaimById();
    // console.log('claimNo is: ', claimNo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClaim]);

  if (currentClaim.adjudication_date)
    currentClaim.adjudication_date = moment(currentClaim.adjudication_date).format('yyyy-MM-DD');
  if (currentClaim.dateApproved)
    currentClaim.dateApproved = moment(currentClaim.dateApproved).format('yyyy-MM-DD');
  if (currentClaim.dateApprovedTwo)
    currentClaim.dateApprovedTwo = moment(currentClaim.dateApprovedTwo).format('yyyy-MM-DD');
  if (currentClaim.dateApprovedDocsBy)
    currentClaim.dateApprovedDocsBy = moment(currentClaim.dateApprovedDocsBy).format('yyyy-MM-DD');

  const ClaimsSchema = Yup.object().shape({
    pay_Cycle_Date: Yup.number().required('you must specify the Transacting Month')
  });

  const formik = useFormik({
    initialValues: currentClaim,
    enableReinitialize: true,
    validationSchema: ClaimsSchema,
    onSubmit: (values) => {
      console.log('values found', values);
    }
  });

  const updateApprovals = async (e) => {
    if (currentClaim.approvedDocsBy == null) {
      notifyPopup(
        `Claims Administrator should approve documents before other Approvals...Not Approved!`,
        'error'
      );
      return;
    }
    if (e === 0 && sessionStorage.getItem('userRefId') !== '12') {
      notifyPopup(`Only Accountant Can Approve This Step...Not Approved!`, 'error');
      return;
    }
    if (e === 1 && sessionStorage.getItem('userRefId') !== '8') {
      notifyPopup(`Only Principal Office Can Authorize This Step...Not Authorized!`, 'error');
      return;
    }
    if (
      e === 2 &&
      sessionStorage.getItem('userRefId') !== '10' &&
      sessionStorage.getItem('userRefId') !== '13'
    ) {
      notifyPopup(`Only CEO or Chairman Can Authorize This Step...Not Authorized!`, 'error');
      return;
    }

    console.log('continued with code');
    setLoading(true);
    fetch(
      `${baseUrl}/api/claims/updateApprovals?claimId=${claimNo}&approvalType=${e}&approvedBy=${userRefId}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned claim', res);
          getClaimById(claimNo);
          setLoading(false);
          notifyPopup(`Claim Approved Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Approving Claim!: ${error}`, 'error');
        }
      );
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const closePopup = () => {
    setOpenPopup(false);
    getClaimById(claimNo);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  /* eslint-disable camelcase */
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Card>
          <CardContent>
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
              onClick={handleLoadingClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Paper>
                  <Grid mb={2} container spacing={2}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      mb="10"
                    >
                      <Grid item xs={3} sm={5}>
                        <Controls.Input name="medFundNumber" label="Policy #" disabled />
                      </Grid>
                      <Grid item xs={4} sm={12} margin={2} mt={2}>
                        <Controls.SelectJson
                          name="status_Id"
                          label="Status"
                          options={claimStatuses}
                          disabled
                        />
                      </Grid>
                    </Stack>
                    <Divider
                      style={{
                        background: '#1a237e',
                        height: 2,
                        margin: 10,
                        width: '80%',
                        paddingTop: 4
                      }}
                      variant="middle"
                    />
                    {/* Documents Approved By */}
                    <Grid item xs={12} sm={4}>
                      <Controls.SelectJson
                        name="approvedDocsBy"
                        label="Approved By Claims Administrator"
                        options={users}
                      />
                    </Grid>
                    <Grid item xs={3} sm={4}>
                      <Controls.InputSimple
                        name="dateApprovedDocsBy"
                        label="Last Doc Approved On"
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={3} sm={2}>
                      <Button
                        fullWidth
                        type="button"
                        variant="outlined"
                        sx={{ color: '#00e676' }}
                        startIcon={<ThumbUpAltIcon />}
                        disabled={
                          formik.values.approvedDocsBy >= 1 || formik.values.status_Id === 17
                        }
                        onClick={() =>
                          notifyPopup(
                            `Document Approval is Automated, Once Claims Administrator approves all documents, Status is Updated...`,
                            'error'
                          )
                        }
                      >
                        Approve
                      </Button>
                    </Grid>
                    <Grid item xs={3} sm={2}>
                      <Button
                        fullWidth
                        type="button"
                        variant="outlined"
                        sx={{ color: '#f44336' }}
                        startIcon={<ThumbDownAltIcon />}
                        disabled={
                          formik.values.approvedDocsBy >= 1 || formik.values.status_Id === 17
                        }
                        onClick={() => {
                          setRejectionLevel(3);
                          setOpenPopup(true);
                        }}
                      >
                        Reject
                      </Button>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Controls.SelectJson
                        name="adjudicatedBy"
                        label="Approved By Accountant"
                        options={users}
                      />
                    </Grid>
                    <Grid item xs={3} sm={4}>
                      <Controls.InputSimple
                        name="adjudication_date"
                        label="Date Approved"
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={3} sm={2}>
                      <Button
                        fullWidth
                        type="button"
                        variant="outlined"
                        sx={{ color: '#00e676' }}
                        startIcon={<ThumbUpAltIcon />}
                        disabled={formik.values.adjudicatedBy > 1 || formik.values.status_Id === 17}
                        onClick={() => updateApprovals(0)}
                      >
                        Approve
                      </Button>
                    </Grid>
                    <Grid item xs={3} sm={2}>
                      <Button
                        fullWidth
                        type="button"
                        variant="outlined"
                        sx={{ color: '#f44336' }}
                        startIcon={<ThumbDownAltIcon />}
                        disabled={formik.values.adjudicatedBy > 1 || formik.values.status_Id === 17}
                        onClick={() => {
                          setRejectionLevel(0);
                          setOpenPopup(true);
                        }}
                      >
                        Reject
                      </Button>
                    </Grid>

                    {/* 1st Approved By */}
                    <Grid item xs={12} sm={4}>
                      <Controls.SelectJson
                        name="approvedBy"
                        label="Authorized By Principal Officer"
                        options={users}
                      />
                    </Grid>
                    <Grid item xs={3} sm={4}>
                      <Controls.InputSimple
                        name="dateApproved"
                        label="Date Authorized"
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={3} sm={2}>
                      <Button
                        fullWidth
                        type="button"
                        variant="outlined"
                        sx={{ color: '#00e676' }}
                        startIcon={<ThumbUpAltIcon />}
                        disabled={formik.values.approvedBy > 1 || formik.values.status_Id === 17}
                        onClick={() => updateApprovals(1)}
                      >
                        Authorize
                      </Button>
                    </Grid>
                    <Grid item xs={3} sm={2}>
                      <Button
                        fullWidth
                        type="button"
                        variant="outlined"
                        sx={{ color: '#f44336' }}
                        startIcon={<ThumbDownAltIcon />}
                        disabled={formik.values.approvedBy > 1 || formik.values.status_Id === 17}
                        onClick={() => {
                          setRejectionLevel(1);
                          setOpenPopup(true);
                        }}
                      >
                        Reject
                      </Button>
                    </Grid>

                    {/* 2nd Approved By */}
                    <Grid item xs={12} sm={4}>
                      <Controls.SelectJson
                        name="approvedByTwo"
                        label="Authorized By CEO/Chairman"
                        options={users}
                      />
                    </Grid>
                    <Grid item xs={3} sm={4}>
                      <Controls.InputSimple
                        name="dateApprovedTwo"
                        label="Date Authorized (Optional)"
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={3} sm={2}>
                      <Button
                        fullWidth
                        type="button"
                        variant="outlined"
                        sx={{ color: '#00e676' }}
                        startIcon={<ThumbUpAltIcon />}
                        disabled={
                          formik.values.approvedByTwo > 1 ||
                          formik.values.approvedBy > 1 ||
                          formik.values.status_Id === 17
                        }
                        onClick={() => updateApprovals(2)}
                      >
                        Authorize
                      </Button>
                    </Grid>
                    <Grid item xs={3} sm={2}>
                      <Button
                        fullWidth
                        type="button"
                        variant="outlined"
                        sx={{ color: '#f44336' }}
                        startIcon={<ThumbDownAltIcon />}
                        disabled={
                          formik.values.approvedByTwo > 1 ||
                          formik.values.approvedBy > 1 ||
                          formik.values.status_Id === 17
                        }
                        onClick={() => {
                          setRejectionLevel(2);
                          setOpenPopup(true);
                        }}
                      >
                        Reject
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
            <Controls.Notification notify={notify} setNotify={setNotify} />
            <Controls.Popup title="Reject Claim" openPopup={openPopup} setOpenPopup={setOpenPopup}>
              <RejectClaimReason
                closePopup={closePopup}
                claimId={claimNo}
                rejectLevel={rejectionLevel}
              />
            </Controls.Popup>
          </CardContent>
        </Card>
      </Form>
    </FormikProvider>
  );
}
